// Add into <ul class="product-slider--product-card-list", but insert after Manual recs

import { buildProductCard } from "./etempa-build-klevu-product-card-v2.js";
import { showLoadingSpinner, arrayChunk } from "./etempa-klevu-helpers.js";
import { etempaKlevuSendCategoryData, etempaKlevuSendRecsViewAnalytics } from "./etempa-klevu-analytics-v2.js";
import { buildKlevuErrorBlock } from "./etempa-klevu-build-error-block.js";
const klevu_js_key = "klevu-163067900222714176";

const priceData = {};
const filterMinMaxData = {};

let productVariantCountArray = [];

let currencySymbol = "£";
let changeCurrency = false;

document.addEventListener("DOMContentLoaded", () => {
  const parent = document.querySelector("product-slider");
  const unorderedList = document.querySelector(".product-slider--product-recommendations");
  const manualRecsCount = parseInt(unorderedList.getAttribute("data-manual-count"));
  const productRecsElement = document.querySelector("product-recommendations");
  const currentKlevuProductId = productRecsElement.getAttribute("data-product-id");
  const klevuLimit = productRecsElement.getAttribute("data-klevu-limit");
  const recsListId = productRecsElement.getAttribute("data-section-id");
  const recsListName = parent.querySelector(".section-heading")?.textContent?.trim() || "Related Products";
  var multipleProductIds = productRecsElement.getAttribute("data-product-ids-multiple");
  var records = [];

  if(multipleProductIds)
  {
    multipleProductIds = multipleProductIds.split(',');
    multipleProductIds.forEach((productId) => {
      let recordItem = {};
      recordItem['id'] = productId;
      records.push(recordItem);
    });
  }
  else
  {
    records = [
      {
        id: currentKlevuProductId,
      },
    ]
  }

  getProducts(klevu_js_key);

  function getProducts(klevu_js_key) {
    let request = {
      recordQueries: [
        {
          id: "recsSimilar",
          typeOfRequest: "RECS_SIMILAR",
          settings: {
            limit: klevuLimit,
            context: {
              recentObjects: [
                {
                  typeOfRecord: "KLEVU_PRODUCT",
                  // records: [
                  //   {
                  //     id: currentKlevuProductId,
                  //   },
                  // ],
                  records: records
                },
              ],
            },
            typeOfRecords: ["KLEVU_PRODUCT"],
          },
        },
      ],
      context: {
        apiKeys: [klevu_js_key],
      },
    };
    runKlevuQuery(request);
  }

  function runKlevuQuery(request) {
    //console.log('[Klevu Recs] Request payload:', JSON.stringify(request, null, 2));
    fetch(`https://rwcsv2.ksearchnet.com/cs/v2/search`, {
      method: "POST",
      // mode: 'cors',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
    })
      .then((response) => {
        if (!response.ok) {
          return response.text().then((body) => {
            //console.error(`[Klevu Recs] API error ${response.status}:`, body);
            throw new Error(`Klevu API returned ${response.status}`);
          });
        }
        return response.json();
      })
      .then((data) => {

        console.log('CHECK DATA HERE: ', data);

        if (data.meta.responseCode === 200) {
          if (
            data.queryResults[0]?.meta.noOfResults > 0 &&
            data.queryResults[0].records.length > 0
          ) {
            const allHandles = data.queryResults[0].records
              .filter((record) => {
                return record.url.includes("rarewaves");
              })
              .map((record) => {
                return record.url.split("/").pop();
              });
            const handles = arrayChunk(allHandles, 20);

            if (current_currency !== "GBP") {
              changeCurrency = true;
              let filterMax = 0;
              let filterMin = 0;
              data.queryResults[0].filters.forEach((filter) => {
                if (filter.key === "klevu_price") {
                  filterMax = filter.max;
                  filterMin = filter.min;
                }
              });

              handles.forEach((handleChunk, index) => {
                // console.log(handleChunk)
                let cacheBustingString = (Math.random() + 1).toString(36).substring(7);
                fetch(
                  `/?handles=${handleChunk.join("_")}&sections=etempa-currency-conversion&max=${filterMax}&min=${filterMin}&type=${cacheBustingString}`,
                  {
                    method: "GET",
                    // mode: 'cors',
                    headers: {
                      "Content-Type": "application/json",
                    },
                  },
                )
                  .then((sectionResponse) => sectionResponse.json())
                  .then((sectionData) => {
                    // console.log("SECTION DATA: ", sectionData);
                    let tempElem = document.createElement("div");
                    tempElem.innerHTML = sectionData["etempa-currency-conversion"];
                    let priceInfoArray = tempElem.querySelectorAll(
                      ".currency-conversion-price-info",
                    );
                    let filterInfoElem = tempElem.querySelector(".currency-conversion-filter-info");
                    if (priceInfoArray && priceInfoArray.length > 0) {
                      currencySymbol = priceInfoArray[0].getAttribute("data-product-price")[0];
                      priceInfoArray.forEach((priceInfo) => {
                        priceData[parseInt(priceInfo.getAttribute("data-product-id").trim())] = {
                          price: priceInfo.getAttribute("data-product-price"),
                          comparePrice: priceInfo.getAttribute("data-product-compare-price"),
                        };
                      });
                    }
                    // console.log("PRICE DATA: ", priceData);
                    if (filterInfoElem) {
                      filterMinMaxData.max = Number(
                        filterInfoElem.getAttribute("data-filter-max").trim(),
                      );
                      filterMinMaxData.min = Number(
                        filterInfoElem.getAttribute("data-filter-min").trim(),
                      );
                    }
                  })
                  .catch((error) => {
                    console.error(error);
                    // error_elem.style.display = "block";
                    // error_text_elem.innerText = error;
                  });
              });
              let displayPriceDataCount = 0;
              const displayPriceData = setInterval(
                () => {
                  // console.log('Object.keys(priceData).length', Object.keys(priceData).length)
                  // console.log('allHandles.length',  allHandles.length);
                  displayPriceDataCount++;

                  if (
                    Object.keys(priceData).length == allHandles.length ||
                    displayPriceDataCount > 20
                  ) {
                    clearInterval(displayPriceData);
                    constructProductsAndFilters(data);
                  }
                },
                250,
                priceData,
                allHandles,
                data,
                displayPriceDataCount,
              );
            } else {
              constructProductsAndFilters(data);
            }
            handles.forEach((handleChunk) => {
              fetch(`/?handles=${handleChunk.join("_")}&sections=etempa-product-has-variants`, {
                method: "GET",
                // mode: 'cors',
                headers: {
                  "Content-Type": "application/json",
                },
              })
                .then((res) => res.json())
                .then((data) => {
                  let tmpHTML = document.createElement("div");
                  tmpHTML.innerHTML = data["etempa-product-has-variants"];
                  let productVariantArray = tmpHTML.querySelector("[data-product-variant-data]");
                  if (productVariantArray != null) {
                    let productVariantData = JSON.parse(productVariantArray.innerText);
                    if (productVariantData.product_data.length > 0) {
                      productVariantCountArray.push(...productVariantData.product_data);
                    }
                    checkForMultipleVariants(productVariantData.product_data);
                  }
                })
                .catch((error) => {
                  console.error(error);
                  // error_elem.style.display = "block";
                  // error_text_elem.innerText = error;
                });
            });
          } else {
            document.dispatchEvent(
              new CustomEvent("klevu:loaded", {
                detail: { count: 0 },
              }),
            );
          }
        } else {
          document.dispatchEvent(
            new CustomEvent("klevu:loaded", {
              detail: { count: 0 },
            }),
          );
          if (manualRecsCount === 0) {
            buildKlevuErrorBlock(parent);
          }
        }
      })
      .catch((error) => {
        console.error(error);
        document.dispatchEvent(
          new CustomEvent("klevu:loaded", {
            detail: { count: 0 },
          }),
        );
      });
  }

  function constructProductsAndFilters(data) {
    const existingHandles = new Set(
      [...unorderedList.querySelectorAll("[data-product-handle]")].map((el) =>
        el.getAttribute("data-product-handle"),
      ),
    );

    let results = data.queryResults[0].records.filter((record) => {
      if (!record.url.includes("rarewaves")) return false;
      const handle = record.url.split("/").pop();
      return !existingHandles.has(handle);
    });

    results.forEach((product) => {
      let link = `/products/${product.url.split("/").pop()}`;
      const listItemClass = "product-slider--product-card-container";
      // console.log("UL IN PRODUCT", unorderedList)
      buildProductCard(
        collection_name,
        collection_handle,
        product,
        changeCurrency,
        priceData,
        currencySymbol,
        collection_section_id,
        departmentMetaObject,
        unorderedList,
        link,
        listItemClass,
      );
    });

    document.dispatchEvent(
      new CustomEvent("klevu:loaded", {
        detail: {
          count: results.length,
        },
      }),
    );
    etempaKlevuSendRecsViewAnalytics(klevu_js_key, recsListId, recsListName, results);
  }

  function buildHref(targetPage) {
    let params = new URLSearchParams();
    params.append("q", searchQuery);
    params.append("page", targetPage);
    params.append("view", limit);
    params.append("grid_list", view);
    params.append("sort_by", sort);
    if (currentFilters.length > 0) {
      currentFilters.forEach((filter) => params.append("filter", filter));
    }
    let href = `/search?${params.toString()}`;
    return href;
  }
});
